import { listen, qs, remove } from "@fluorescent/dom";

import { section } from "@/glow";
import { AnimateVideo } from "@/lib/animation";

const selectors = {
  inner: ".video__inner",
  player: "[data-video-player]",
  button: "[data-play-button]",
  overlay: "[data-overlay]",
  image: ".video__image",
  iframe: "iframe",
  videoWrapper: ".video__wrapper",
};

const classes = {
  visible: "visible",
};

section("video", {
  events: [],

  onLoad() {
    this.AnimateVideo = AnimateVideo(this.container);

    import(flu.chunks.video).then(({ Video }) => {
      const videoWrapper = qs(selectors.videoWrapper, this.container);
      const { videoId, videoType } = videoWrapper.dataset;

      if (!videoId || !videoType) return;

      const player = qs(selectors.player, this.container);
      const button = qs(selectors.button, this.container);
      const overlay = qs(selectors.overlay, this.container);
      const image = qs(selectors.image, this.container);

      const video = Video(this.container, {
        id: videoId,
        type: videoType,
        playerEl: player,
      });

      video.on("play", () => {
        const iframe = qs(selectors.iframe, this.container);
        iframe.taxindex = 0;
        iframe.focus();

        remove(overlay, classes.visible);
        image && remove(image, classes.visible);
      });

      this.events.push(
        listen(button, "click", () => {
          video.play();
        })
      );
    });
  },

  onUnload() {
    this.events.forEach(unsubscribe => unsubscribe());
    this.AnimateVideo?.destroy();
  },
});
